/**
 * Transactions API — real backend calls.
 * See BACKEND_CONTRACT.md.
 */

import axiosInstance from './axiosInstance';

/**
 * List user's transactions.
 *
 * BACKEND: GET /transactions
 * QUERY:   ?from=&to=&status=&page=&pageSize=
 * SUCCESS: { data: { transactions: [...] }, meta: { total } }
 *
 * @param {object} [params]
 */
export async function listTransactions(params = {}) {
  const res = await axiosInstance.get('/transactions', { params });
  return res.data;
}

/**
 * Get a single transaction by ID (for receipt details).
 *
 * BACKEND: GET /transactions/:id
 * SUCCESS: { data: { transaction: {...} } }
 *
 * @param {string} id
 */
export async function getTransaction(id) {
  const res = await axiosInstance.get(`/transactions/${id}`);
  return res.data.data.transaction;
}

export const transactionsApi = { listTransactions, getTransaction };
export default transactionsApi;
